import { apiClient } from '@/shared/api';

import type {
  CustomerAccountSummary,
  CustomerAddress,
  CustomerConsent,
  CustomerContact,
  CustomerRecipient,
  CustomerSearchRequest,
  CustomerSearchResponse,
  CustomerSummary,
} from '../model/types';

const BASE = '/api/v1/internal/customers';

export async function searchCustomers(request: CustomerSearchRequest): Promise<CustomerSearchResponse> {
  return (await apiClient.post<CustomerSearchResponse>(`${BASE}/search`, request)).data;
}

export async function getCustomerSummary(customerId: string): Promise<CustomerSummary> {
  return (await apiClient.get<CustomerSummary>(`${BASE}/${customerId}/summary`)).data;
}

export async function getCustomerContacts(customerId: string): Promise<CustomerContact[]> {
  return (await apiClient.get<CustomerContact[]>(`${BASE}/${customerId}/contacts`)).data;
}

export async function getCustomerAddresses(customerId: string): Promise<CustomerAddress[]> {
  return (await apiClient.get<{ addresses: CustomerAddress[] }>(`${BASE}/${customerId}/addresses`)).data.addresses;
}

export async function getCustomerRecipients(customerId: string): Promise<CustomerRecipient[]> {
  return (await apiClient.get<{ recipients: CustomerRecipient[] }>(`${BASE}/${customerId}/recipients`)).data.recipients;
}

export async function getCustomerConsents(customerId: string): Promise<CustomerConsent[]> {
  return (await apiClient.get<CustomerConsent[]>(`${BASE}/${customerId}/consents/effective`)).data;
}

export async function getCustomerAccounts(customerId: string): Promise<CustomerAccountSummary[]> {
  return (await apiClient.get<CustomerAccountSummary[]>(`${BASE}/${customerId}/accounts`)).data;
}
